import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import AddressImg from "./AddressImg";
import { Fade } from "react-reveal";
import "./ContactComponent.css";
import { greeting, contactPageData } from "../../portfolio.js";

const ContactData = contactPageData.contactSection;
const addressSection = contactPageData.addressSection;
const phoneSection = contactPageData.phoneSection;

class Contact extends Component {
  render() {
    const theme = this.props.theme;

    return (
      <div className="contact-main" style={{ background: theme.body }}>
        <Header theme={theme} />

        <div className="basic-contact">
          <div className="contact-wrapper">
            {/* LEFT CARD – PROFILE / SOCIAL / RESUME */}
            <Fade bottom duration={1000} distance="40px">
              <div
                className="contact-card contact-left"
                style={{ background: theme.card, color: theme.text }}
              >
                {/* Floating avatar */}
                <div className="contact-avatar-wrapper">
                  <img
                    src={require(`../../assets/images/${ContactData["profile_image_path"]}`)}
                    alt="Profile"
                    className="contact-avatar"
                  />
                </div>

                <div className="contact-card-content">
                  <h1
                    className="contact-title"
                    style={{ color: theme.text }}
                  >
                    {ContactData["title"]}
                  </h1>

                  <p
                    className="contact-subtitle"
                    style={{ color: theme.secondaryText }}
                  >
                    {ContactData["description"]}
                  </p>

                  <div className="contact-social-section">
                    <SocialMedia theme={theme} />
                  </div>

                  <div className="resume-btn-div">
                    <Button
                      text="See My Resume"
                      newTab={true}
                      href={greeting.resumeLink}
                      theme={theme}
                    />
                  </div>
                </div>
              </div>
            </Fade>

            {/* RIGHT CARD – MAIL / ADDRESS / PHONE / MAP */}
            <Fade bottom duration={1000} distance="40px">
              <div
                className="contact-card contact-right"
                style={{ background: theme.card, color: theme.text }}
              >
                <div className="contact-graphic">
                  <AddressImg theme={theme} />
                </div>

                <div className="contact-card-content">
                  {/* Mail section (before address) */}
                  <div className="mail-section">
                    <h2
                      className="contact-section-heading"
                      style={{ color: theme.text }}
                    >
                      Mail Me
                    </h2>
                    <p
                      className="contact-section-text"
                      style={{ color: theme.secondaryText }}
                    >
                      Have a question, opportunity, or just want to say hi?
                      Feel free to drop me an email anytime.
                    </p>

                    <div className="mail-info">
                      {greeting.email && (
                        <span
                          className="mail-email"
                          style={{ color: theme.secondaryText }}
                        >
                          {greeting.email}
                        </span>
                      )}
                      <div className="mail-btn-wrapper">
                        <Button
                          text="Send Email"
                          newTab={true}
                          href={
                            greeting.email
                              ? `mailto:${greeting.email}`
                              : "#"
                          }
                          theme={theme}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Address section */}
                  <h2
                    className="contact-section-heading"
                    style={{ color: theme.text }}
                  >
                    {addressSection["title"]}
                  </h2>
                  <p
                    className="contact-section-text"
                    style={{ color: theme.secondaryText }}
                  >
                    {addressSection["subtitle"]}
                  </p>

                  {/* Phone section */}
                  <h2
                    className="contact-section-heading"
                    style={{ color: theme.text }}
                  >
                    {phoneSection["title"]}
                  </h2>
                  <p
                    className="contact-section-text"
                    style={{ color: theme.secondaryText }}
                  >
                    {phoneSection["subtitle"]}
                  </p>

                  <div className="address-btn-div">
                    <Button
                      text="Visit on Google Maps"
                      newTab={true}
                      href={addressSection.location_map_link}
                      theme={theme}
                    />
                  </div>
                </div>
              </div>
            </Fade>
          </div>
        </div>

        <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Contact;
